"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _facepaint = _interopRequireDefault(require("facepaint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(theme) {
  return (0, _facepaint["default"])(["@media(min-width: ".concat(theme.breakpoints[0], "px)")]);
};

exports["default"] = _default;